// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinearProgress-root {
  background-color: #26282F;
  height: 4px;
  overflow: hidden;
  position: absolute;
  width: 100%;
}
.LinearProgress-root .LinearProgress-bar {
  height: 4px;
  width: auto;
  background-color: #FFF;
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  -webkit-transition: -webkit-transform 0.2s linear;
  transition: -webkit-transform 0.2s linear;
  transition: transform 0.2s linear;
  transition: transform 0.2s linear, -webkit-transform 0.2s linear;
  -webkit-transform-origin: left;
          transform-origin: left;
}
.LinearProgress-root .LinearProgress-bar1 {
  -webkit-animation: LinearProgress-keyframes-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
          animation: LinearProgress-keyframes-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
}
.LinearProgress-root .LinearProgress-bar2 {
  -webkit-animation: LinearProgress-keyframes-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
          animation: LinearProgress-keyframes-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
  -webkit-animation-delay: 1.15s;
          animation-delay: 1.15s;
}

@-webkit-keyframes LinearProgress-keyframes-indeterminate1 {
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
}

@keyframes LinearProgress-keyframes-indeterminate1 {
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
}
@-webkit-keyframes LinearProgress-keyframes-indeterminate2 {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}
@keyframes LinearProgress-keyframes-indeterminate2 {
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/LoadingLinear/styles.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,yBCiDQ;EDhDR,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AADF;AAGE;EACE,WAAA;EACA,WAAA;EACA,sBCJI;EDKJ,MAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;EAAA,yCAAA;EAAA,iCAAA;EAAA,gEAAA;EACA,8BAAA;UAAA,sBAAA;AADJ;AAIE;EACE,gHAAA;UAAA,wGAAA;AAFJ;AAKE;EACE,2GAAA;UAAA,mGAAA;EACA,8BAAA;UAAA,sBAAA;AAHJ;;AAOA;EACE;IACE,UAAA;IACA,WAAA;EAJF;EAOA;IACE,UAAA;IACA,WAAA;EALF;EAQA;IACE,UAAA;IACA,WAAA;EANF;AACF;;AARA;EACE;IACE,UAAA;IACA,WAAA;EAJF;EAOA;IACE,UAAA;IACA,WAAA;EALF;EAQA;IACE,UAAA;IACA,WAAA;EANF;AACF;AASA;EACE;IACE,WAAA;IACA,WAAA;EAPF;EAUA;IACE,UAAA;IACA,UAAA;EARF;EAWA;IACE,UAAA;IACA,UAAA;EATF;AACF;AALA;EACE;IACE,WAAA;IACA,WAAA;EAPF;EAUA;IACE,UAAA;IACA,UAAA;EARF;EAWA;IACE,UAAA;IACA,UAAA;EATF;AACF","sourcesContent":["@import '../../../Global/Colors';\n\n.LinearProgress-root {\n  background-color: $Gray200;\n  height: 4px;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n\n  .LinearProgress-bar {\n    height: 4px;\n    width: auto;\n    background-color: $White;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    position: absolute;\n    transition: transform 0.2s linear;\n    transform-origin: left;\n  }\n\n  .LinearProgress-bar1 {\n    animation: LinearProgress-keyframes-indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;\n  }\n\n  .LinearProgress-bar2 {\n    animation: LinearProgress-keyframes-indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;\n    animation-delay: 1.15s;\n  }\n}\n\n@keyframes LinearProgress-keyframes-indeterminate1 {\n  0% {\n    left: -35%;\n    right: 100%;\n  }\n\n  60% {\n    left: 100%;\n    right: -90%;\n  }\n\n  100% {\n    left: 100%;\n    right: -90%;\n  }\n}\n\n@keyframes LinearProgress-keyframes-indeterminate2 {\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
